import * as React from 'react';
import * as moment from 'moment';
import 'moment-timezone';

import { Logger, Reading } from './Models';

type WCLogger = {
    id: number;
    colour: string;
    chartLabel: string;
};

type WCReading = {
    loggerId: number;
    x: number;
    y: number;
};

type Props = {
    loggers: Array<Logger>;
    data: Array<Reading>;
    label: string;
    symbol: string;

    minimumValue?: number | null;
    maximumValue?: number | null;

    startTime?: moment.Moment | number | null;
    endTime?: moment.Moment | number | null;

    className?: string;
    style?: React.CSSProperties;
};

const toEpochMsOrNull = (v: moment.Moment | number | null | undefined): number | null => {
    if (v == null) return null;
    if (typeof v === 'number') return Number.isFinite(v) ? v : null;
    if (moment.isMoment(v)) return v.valueOf();
    return null;
};

export default class TimeseriesChartWrapper extends React.Component<Props> {
    private elRef = React.createRef<HTMLElement>();

    public componentDidMount() {
        this.applyProps();
    }

    public componentDidUpdate() {
        this.applyProps();
    }

    private applyProps() {
        const el = this.elRef.current as any;
        if (!el) {
            return;
        }

        const wcLoggers: Array<WCLogger> = (this.props.loggers || []).map(l => ({
            id: l.id,
            colour: l.colour,
            chartLabel: l.chartLabel
        }));

        const wcData: Array<WCReading> = (this.props.data || [])
            .map(r => ({
                loggerId: r.loggerId,
                x: moment.isMoment(r.x) ? r.x.valueOf() : Number((r as any).x),
                y: Number(r.y)
            }))
            .filter(p => Number.isFinite(p.x) && Number.isFinite(p.y));

        el.loggers = wcLoggers;
        el.data = wcData;

        const minV = this.props.minimumValue;
        if (minV == null) el.removeAttribute('minimum-value');
        else el.setAttribute('minimum-value', String(minV));

        const maxV = this.props.maximumValue;
        if (maxV == null) el.removeAttribute('maximum-value');
        else el.setAttribute('maximum-value', String(maxV));

        const startMs = toEpochMsOrNull(this.props.startTime);
        if (startMs == null) el.removeAttribute('start-ms');
        else el.setAttribute('start-ms', String(startMs));

        const endMs = toEpochMsOrNull(this.props.endTime);
        if (endMs == null) el.removeAttribute('end-ms');
        else el.setAttribute('end-ms', String(endMs));
    }

    public render() {
        const { label, symbol, className, style } = this.props;

        return (
            <timeseries-chart
                ref={this.elRef as any}
                label={label}
                symbol={symbol}
                className={className}
                style={style}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/TimeseriesChartWrapper.tsx